import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";

export const GetLinkedBookings = async (bookingId: string) => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.COLLINS_API_BASE_URL}/bookings/${bookingId}/linked`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (response.ok) {
      return (await response.json()).bookings as string[];
    }

    apiFetchNotOkHandler(response, "Error fetching linked bookings");
    return [];
  } catch (error) {
    errorHandler(error, "Error fetching linked bookings");

    return [];
  }
};
